import { app } from 'src/configuration'

export const filterGeoAddressByPostalCode = (postalCode: string) => {
  const allowedZones = app.ADDRESS_API_ALLOWED_ZONES
  const initials = postalCode.slice(0, 2)
  return allowedZones.length > 0 ? allowedZones.includes(initials) : true
}
